import { render } from "./NotFound.vue?vue&type=template&id=2b658b6a&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=2b658b6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b658b6a"]])

export default __exports__